/* eslint-disable */
import axios from "axios";

export async function setCommentAPI (params) {
	let responseData = null, id = params.post.id
	delete params.post
	await axios
		.post('comments/' + id, params)
		.then(response => {
			console.log("SET COMMENT SUCCESS", response);
			responseData = {
				data: response.data.data,
				success: true
			}
		})
		.catch(error => {
			console.log("SET COMMENT ERROR", error);
		})
	return responseData
}

export async function editCommentAPI (comment) {
	let responseData = null
	await axios
		.patch('comments/' + comment.id, comment)
		.then(response => {
			console.log("EDIT COMMENT SUCCESS", response);
			responseData = {
				data: response.data.data,
				success: true
			}
		})
		.catch(error => {
			console.log("EDIT COMMENT ERROR", error);
		})
	return responseData
}

export async function removeCommentAPI (id, params) {
	let responseData = false
	await axios
		.delete('comments/' + id, {
			params: params
		})
		.then(response => {
			console.log("REMOVE COMMENT SUCCESS", response);
			responseData = {
				data: response.data.data,
				success: true
			}
		})
		.catch(error => {
			console.log("REMOVE COMMENT ERROR", error);
		})
	return responseData
}

// export async function removeCommentAuthAPI (id) {
// 	let responseData = false
// 	await axios
// 		.get('comments/auth-to-delete/' + id)
// 		.then(response => {
// 			console.log("GET REMOVE COMMENT AUTH SUCCESS", response);
// 			responseData = {
// 				data: response.data,
// 				success: true
// 			}
// 		})
// 		.catch(error => {
// 			console.log("GET REMOVE COMMENT AUTH ERROR", error);
// 		})
// 	return responseData
// }

export async function getCommentsAPI (id, params) {
	let responseData = null
	await axios
		.get('comments/' + id + '/list', {
			params: params
		})
		.then(response => {
			console.log("GET COMMENTS SUCCESS", response);
			responseData = {
				data: response.data,
				success: true
			}
		})
		.catch(error => {
			console.log("GET COMMENTS ERROR", error);
		})
	return responseData
}

export async function getAnswersAPI (id, params) {
	let responseData = null
	await axios
		.get('comments/' + id + '/children', {
			params: params
		})
		.then(response => {
			console.log("GET COMMENT ANSWERS SUCCESS", response);
			responseData = {
				data: response.data,
				success: true
			}
		})
		.catch(error => {
			console.log("GET COMMENT ANSWERS ERROR", error);
		})
	return responseData
}
